export enum TrackerType {
  FREQUENCY = 'frequency',
  RATE = 'rate',
  DURATION = 'duration',
  INTERVAL = 'interval',
}
